import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import CTAButton from "../../../../components/buttons/CTAButton";
import { Avatar, Box, Container, Typography } from "@mui/material";
const testimonials = [
  {
    comment:
      "The most amazing travel experience I've ever had. The attention to detail and personalized service was outstanding.",
    name: "Dorcas",
    bio: "Travel Enthusiast",
    src: "https://images.unsplash.com/photo-1533146692536-e70f31e14b36?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
  },
  {
    comment:
      "Incredible destinations and perfectly planned itineraries. They made our dream vacation a reality",
    name: "Thomas",
    bio: "Adventure Seeker",
    src: "https://images.unsplash.com/photo-1542727313-4f3e99aa2568?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
  },
  {
    comment:
      "Outstanding service from start to finish. They took care of everything, making our family trip stress-free.",
    name: "Nana",
    bio: "CEO- Elbee Transcription",
    src: "https://images.unsplash.com/photo-1596510914965-9ae08acae566?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=749&q=80",
  },
  {
    comment:
      "Outstanding service from start to finish. They took care of everything, making our family trip stress-free.",
    name: "Sampson",
    bio: "Family Traveler",
    src: "https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
  },
];

const Testimonials = () => {
  const Carousel = ({ children }) => {
    const settings = {
      // dots: true,
      infinite: true,
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 5000,
      cssEase: "linear",
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <Box>
        <Slider {...settings}>{children}</Slider>
      </Box>
    );
  };

  return (
    <Container className="relative z-20">
      <Box width="100%" color={"#fff"}>
        <Carousel>
          {testimonials.map((testimonial, index) => {
            return (
              <div>
                <Box
                  p={4}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  rowGap={1}
                >
                  <Avatar
                    sx={{
                      bgcolor: "info.light",
                      width: { xs: 60, md: 80 },
                      height: { xs: 60, md: 80 },
                    }}
                    alt="testimonial"
                    src={testimonial.src}
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      variant={{ xs: "body2", md: "p1" }}
                      textAlign="center"
                      fontWeight={500}
                    >
                      {testimonial.name}
                    </Typography>
                    <Typography
                      variant={{ xs: "body2", md: "p1" }}
                      textAlign="center"
                      fontWeight={500}
                      sx={{ fontSize: { xs: "0.7rem", md: "" } }}
                    >
                      ({testimonial.bio})
                    </Typography>
                  </Box>
                  <Typography
                    variant={{ xs: "body2", md: "p1" }}
                    textAlign="center"
                    sx={{
                      fontSize: { xs: "0.7rem", md: "" },
                      fontStyle: "italic",
                    }}
                  >
                    "{testimonial.comment}"
                  </Typography>
                </Box>
              </div>
            );
          })}
        </Carousel>
      </Box>
      <Box
        sx={{
          width: { xs: "90%", md: "80%" },
          mx: "auto",
          textAlign: "center",
          py: 4,
          color: "#fff",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "'Ubuntu', sans-serif",
          }}
          variant="h4"
        >
          Begin your traveling and learning journey with us.{" "}
        </Typography>
        {/* <Box sx={{ width: { xs: "80%", md: "70" }, mx: "auto" }}> */}
        <div class="mt-6">
          <a
            target="_blank"
            href="https://wa.me/message/VIGHOLT7SHWFJ1"
            class="px-6 py-3 text-lg font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
          >
            Get Started
          </a>
        </div>
      </Box>
    </Container>
  );
};

export default Testimonials;
